export default __webpack_public_path__ + "static/media/brown_base.79362c98.png";